
import { combineReducers } from 'redux';
import { connectRouter } from "connected-react-router";
import { reducer as formReducer } from 'redux-form';

import bladeReducer from "./Blade";
import confirmReducer from "./Confirm";
import modalReducer from "./Modal";
import sessionReducer from "./Session";
import notificationReducer from './Notifications';
import globalReducer from "./Global";

import librariesReducer from './Libraries';
import libraryPropertiesReducer from './LibraryProperties';
import advertiserDetails from './AdvertiserDetails';

import creativesReducer from "./Creatives";
import creativePreviewsReducer from "./CreativePreviews";
import contentFeedsReducer from "./ContentFeeds";
import socialReducer from "./Social";
import conceptsReducer from "./Concepts";
import conceptDetailsReducer from "./ConceptDetails";
import creativeVersionsReducer from "./CreativeVersions";
import importVersionsReducer from "./ImportVersions";
import imposiumProjectsReducer from "./ImposiumProjects";
import imposiumCompositionsReducer from "./ImposiumCompositions";
import afterEffectsPackagesReducer from "./AfterEffectsPackages";
import afterEffectsCompositionsReducer from "./AfterEffectsCompositions";
import creativeApprovalsReducer from "./CreativeApprovals";
import dtreesReducer from "./DTrees";
import creativeReducer from "./CreativeDetails";
import assetReducer from "./Assets";
import versionDetailReducer from "./VersionDetails";
import existingCreativesReducer from "./creatives/ExistingCreatives";
import qrCodesReducer from "./QrCodes";
import qrDesignsReducer from "./QrDesigns";
import contentFeedDecisioningReducer from "./ContentFeedDecisioning";
import contentFeedDetailsReducer from './ContentFeedDetails';
import contentFeedMappingReducer from "./ContentFeedMapping";

import labelsReducer from "./Labels";
import refinementsReducer from "./Refinements";
import versionGenerationReducer from "./VersionGeneration";

import qaReducer from "./QA";
import submissionReducer from "./QASubmission";
import qaReportsReducer from "./QAReports";

import downloadReducer from "./Download";
import selectedReducer from "./Selected";
import userReducer from "./You";

import assignContentFeedReducer from "./AssignContentFeed";
import assignedCreativesReducer from "./AssignedCreatives";
import predictiveScoringReducer from "./PredictiveScoring";
import updatesHistoryReducer from "./UpdatesHistory";

function makeRootReducer(asyncReducers, routerHistory){
	return combineReducers({
		// External Reducers
		form:   formReducer,
		router: connectRouter(routerHistory),

		// Common Reducers
		you:           userReducer,
		confirm:       confirmReducer,
		session:       sessionReducer,
		blade:         bladeReducer,
		modal:         modalReducer,
		notifications: notificationReducer,
		global:        globalReducer,

		// Application Specific Reducers
		libraries:     librariesReducer,
		libraryProperties: libraryPropertiesReducer,

		social: socialReducer,
		concepts:  conceptsReducer,
		creativePreviews:  creativePreviewsReducer,
		contentFeeds: contentFeedsReducer,
		conceptDetails:conceptDetailsReducer,
		creatives: creativesReducer,
		creativeDetails:creativeReducer,
		creativeVersions: creativeVersionsReducer,
		importVersions: importVersionsReducer,
		imposiumProjects: imposiumProjectsReducer,
		aePackages: afterEffectsPackagesReducer,
		aeCompositions: afterEffectsCompositionsReducer,
		imposiumCompositions: imposiumCompositionsReducer,
		creativeApprovals: creativeApprovalsReducer,
		existingCreatives: existingCreativesReducer,
		dtrees: dtreesReducer,
		assets:assetReducer,
		versionDetails:versionDetailReducer,
		qrCodes: qrCodesReducer,
		qrDesigns: qrDesignsReducer,
		contentFeedDecisioning: contentFeedDecisioningReducer,
		contentFeedDetails: contentFeedDetailsReducer,
		contentFeedMapping: contentFeedMappingReducer,

		labels: labelsReducer,
		refinements: refinementsReducer,
		versionGeneration: versionGenerationReducer,

		download:downloadReducer,
		selected:selectedReducer,
		advertiserDetails,
		qa:qaReducer,
		qaSubmission:submissionReducer,
		qaReports: qaReportsReducer,

		assignContentFeed: assignContentFeedReducer,
		assignedCreatives: assignedCreativesReducer,
		updatesHistory: updatesHistoryReducer,
		predictiveScoring: predictiveScoringReducer,
	});
}

export default makeRootReducer;
